<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  created() {
  	require('./utils/rem.js')
  },
  beforeCreate() {
    this.$nextTick(() => {
      document.body.setAttribute('style', 'background:#f6f7fa;font-size:14px')
    })
  },
  // beforeCreate() {
	 //  let script = document.createElement('script');
	 //  script.type = 'text/javascript';
	 //  script.src = 'https://apis.google.com/js/api:client.js';
	 //  document.body.appendChild(script);
	 //  let script1 = document.createElement('script');
	 //  script1.type = 'text/javascript';
	 //  script1.src = 'https://connect.facebook.net/zh_CN/sdk.js#xfbml=1&version=v3.3&appId=763593711432041&autoLogAppEvents=1';
	 //  document.body.appendChild(script1);
  // },
  //实例销毁之前钩子--移除body 标签的属性style
  beforeDestroy() {
    document.body.removeAttribute('style')
  },
}
</script>

<style lang="scss">
// 992px -1200px
// 768 - 992
// 0 - 768
// @media (min-width: 992px) and (max-width: 1200px){
// 	.header{
// 		background: red!important;
// 	}
// }
@font-face {
  font-family: "PingFang";
  src: url("./static/font/PINGFANG BOLD.TTF");
}
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	letter-spacing: 0.5px;
	font-family: "PingFang";
}
.flex{
	display: flex;
}
.f-ct{
	align-items: center;
}
.f-bt{
	justify-content: space-between;
}
.f-w{
	flex-wrap: wrap;
}
.f-btc{
	justify-content: center;
}
.line1 {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.line2 {
	overflow:hidden; 
	// text-overflow:ellipsis;
	display:-webkit-box;
	 /*! autoprefixer: off; */  
	-webkit-box-orient:vertical;
	-webkit-line-clamp:2; 
}
.line3 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	 /*! autoprefixer: off; */  
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}
.line3 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	 /*! autoprefixer: off; */  
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
}
div {
	color: #2e3341;
}
.orange {
  color: #ef5843;
}
/* 添加手形 */
.pointer {
  cursor: pointer;
}

// 宽度小于1200px
// @media screen and (min-width: 1200px){
// 	.user_bor {
// 	  border: 1px solid #e9e9e9;
// 	  box-shadow: 0px 0px 1px #e9e9e9;
// 	  border-radius: 4px;
// 	  padding: 22px 0px;
// 	  margin-top: 20px;
// 	}
// }


.user_bor {
	width: 100%;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 0px 1px #e9e9e9;
  border-radius: 4px;
  padding: 22px 0px;
  margin-top: 20px;
}

.user_box_left {
  font-size: 16px;
  font-weight: bold;
}

.jiacu {
  font-weight: bold;
}

.el-dialog__title {
  font-weight: bold;
}

.el-dialog {
  margin-top: 15vh !important;
  border-radius: 5px !important;
}

input::-webkit-input-placeholder {
  color: #626775 !important;
}

input::-moz-input-placeholder {
  color: #626775 !important;
}

input::-ms-input-placeholder {
  color: #626775 !important;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 10px;

}

/* 后期添加的滚动条 */
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fff !important;
  border: 2px solid #ef5843 !important;
  line-height: 24px !important;
  color: #7e7e8a !important;
}

.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  color: #2f3442 !important;
}

.tablemain {
  .el-table__header {
    height: 64px !important;

  }
}

.el-table--border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}


html {
  overflow-y: scroll; 
}
 
:root {
  overflow-y: auto;
  overflow-x: hidden;
}
 
:root body {
  position: absolute;
}
 
body {
  width: 100vw;
  overflow: hidden;
}
</style>
